import {Dropdown, Space, Tooltip} from "antd";
import { useSelector } from "react-redux";
import {CaretDownOutlined} from "@ant-design/icons";

const PageHeader = ({ title, history }) => {
    const domainGroups = useSelector(
        state => state.auth.user.user.domain_groups
    );

    const ipGroups = useSelector(
        state => state.auth.user.user.ip_address_groups
    );

    const parts = history.location.pathname
        .split("/")
        .filter(Boolean);

    const section = parts[0];
    const guid = parts[1];

    let groups = null;

    if (section === "domains" && guid) {
        groups = domainGroups;
    }

    if (section === "ip-addresses" && guid) {
        groups = ipGroups;
    }

    if (!groups) {
        return (
            <h2 className="main-header-text">
                {title}
            </h2>
        );
    }

    const currentGroup = groups.find(
        group => group.guid === guid
    );

    const items = groups.map(group => ({
        key: group.guid,
        label: group.name,
        style: group.guid === guid ? {backgroundColor: '#f5f5f5', fontWeight: '500'} : null
    }));

    const handleClick = ({ key }) => {
        history.push(`/${section}/${key}`);
    };

    return (
        <Dropdown
            menu={{
                items,
                onClick: handleClick
            }}
            trigger={["click"]}
        >
            <h2 className="main-header-text" style={{
                    cursor: "pointer",
                    margin: 0
                }}>
                <Tooltip title='Select group' placement='right'>
                    <Space>
                        {currentGroup?.name || title}
                        <CaretDownOutlined style={{ fontSize: 10 }} />
                    </Space>
                </Tooltip>
            </h2>
        </Dropdown>
    );
};

export default PageHeader;